export type ISearch = {
    searchString?: string;
    searchBy?: string;
    sortBy?: string;
    sortOrder?: SORT;
};

export type IPaginatedRequest = {
    pageNumber: number;
    pageSize: number;
};

export type IPaginatedSearch = IPaginatedRequest & ISearch;

export interface IPaginatedResult<T> {
    content: T[];
    pageNumber: number;
    pageSize: number;
    numberOfElements: number;
}

export interface IPaginatedResultWrapper<T> extends IPaginatedResult<T> {
    error?: string;
    isFetching: boolean;
    success?: boolean;
}

export interface IResponseWrapper<T> {
    data?: T;
    error?: string;
    isFetching: boolean;
    success?: boolean;
}

export enum SORT {
    NEUTRAL = '',
    ASC = 'ASC',
    DESC = 'DESC',
}
